import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../components/landing/main/main.component';
import { FadPersonalComponent } from '../components/landing/fad-personal/fad-personal.component';
import { FadEmpresaComponent } from '../components/landing/fad-empresa/fad-empresa.component';
import { SoporteComponent } from '../components/landing/soporte/soporte.component';
import { FaqsComponent } from '../components/landing/faqs/faqs.component';
import { LoginComponent } from '../components/application/login/login.component';
import { CreateUserComponent } from '../components/landing/create-user/create-user.component';
import { PrivacyNoticeComponent } from '../components/landing/privacy-notice/privacy-notice.component';
import { CumplimientoJuridicoComponent } from '../components/landing/cumplimiento-juridico/cumplimiento-juridico.component';
import {ThanksPageComponent} from '../components/landing/thanks-page/thanks-page.component';
import {PurchaseSummaryComponent} from '../components/application/payment/purchase-summary/purchase-summary.component';
import {PaymentComponent} from '../components/application/payment/payment.component';
import {AvisoPrivacidadComponent} from '../components/landing/aviso-privacidad/aviso-privacidad.component';
import {SecurityInformationComponent} from '../components/landing/security-information/security-information.component';

const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'assinatura-digital-para-pessoas', component: FadPersonalComponent },
  { path: 'assinatura-digital-para-empresas', component: FadEmpresaComponent },
  { path: 'como-comecar-a-assinar-digitalmente', component: SoporteComponent },
  { path: 'perguntas-frequentes-da-assinatura-digital-fad', component: FaqsComponent },
  { path: 'iniciar-sessao', component: LoginComponent },
  { path: 'assinatura-digital-gratis', component: CreateUserComponent },
  { path: 'termos-e-condicoes', component: PrivacyNoticeComponent },
  { path: 'aviso-de-privacidade', component: AvisoPrivacidadComponent},
  { path: 'conformidade-legal-da-assinatura-digital', component: CumplimientoJuridicoComponent },
  { path: 'comprar-assinatura-digital', component: PaymentComponent },
  { path: 'sucesso-compra-assinatura-digital', component: PurchaseSummaryComponent },
  { path: 'obrigado-por-nos-contatar', component: ThanksPageComponent },
  { path: 'politica-de-seguranca', component: SecurityInformationComponent },
  { path: '**', pathMatch: 'full', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class RoutingModule { }
